import React, { useEffect, useState } from "react";
import Config from "./../Config";

export const PosthogWrapper = ({ children }) => {
	const [PostHogProvider, setPostHogProvider] = useState(null);

	useEffect(() => {
		const loadPosthog = async () => {
			const { PostHogProvider: PHProvider } = await import("posthog-js/react");
			setPostHogProvider(() => PHProvider);
		};

		if ("requestIdleCallback" in window) {
			requestIdleCallback(loadPosthog);
		} else {
			setTimeout(loadPosthog, 1000);
		}
	}, []);

	if (!PostHogProvider) return children;

	return (
		<PostHogProvider
			apiKey={Config.POSTHOG_KEY}
			options={{ api_host: Config.POSTHOG_API }}
		>
			{children}
		</PostHogProvider>
	);
};
